/**
 * Runs per-item validation and namespaces keys as `${key}.${index}.${field}`
 * so RHF / CrudGrid path-style field errors keep matching form rows.
 */
export function validateCollection(key, items, validateItem, ctx) {
    const errors = {};
    items.forEach((item, i) => {
        const itemErrors = validateItem(item, i, ctx);
        if (itemErrors) {
            for (const [f, m] of Object.entries(itemErrors)) {
                errors[`${key}.${i}.${f}`] = m;
            }
        }
    });
    return errors;
}
//# sourceMappingURL=validateCollection.js.map